import React from "react";
import {Close, PlaylistAdd, Share, Star, StarBorder} from "@material-ui/icons";
import {
  Behance,
  Facebook,
  Instagram,
  LinkedIn,
  SoundCloud,
  Spotify,
  Twitter,
  Vimeo,
  Web,
  Youtube,
  Email,
  Twitch,
  Tiktok,
  Linktree
} from "../SocialIcons";
import styled from "styled-components";
import {IconButton, Tooltip} from "@material-ui/core";
import localization from "../../../config/localization";
import {addHttpToUrl} from "../../../utils";
import {getActiveClient} from "../../../api-client/core/authentication/utils";
import AddToPlaylist from "../AddToPlaylist";

export default ({
  id,
  name,
  picture,
  blur,
  socialLinks,
  onClose,
  onToggleFavorite,
  favorite,
  showFavoriteButton = true,
  showShareButton = false,
  showAddToPlaylistButton = false,
  onAddToPlaylist,
  onShare,
  showContact,
  onContact,
  isPublic= false,
}) => {
  return (
    <SocialBanner sizeXl={true}>
      {!isPublic &&
        <CloseButton style={{zIndex: 150}}>
          <IconButton onClick={onClose}>
            <Close style={{fontSize: "30px", color: "#676767"}}/>
          </IconButton>
        </CloseButton>
      }
      <div style={{width:"100%", marginBottom: 10, marginTop: 7, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
        <Profile picture={picture} blur={blur} />
      </div>
      <SocialButtons>
        {renderSocialLinksButtons(socialLinks)}
      </SocialButtons>
      <Separator />
      {showContact && <Contact onClick={onContact}>{localization.get('contact')}</Contact>}
      {/* <Name className="multiline-ellipsis">{name}</Name> */}
      <div style={{display: "flex"}}>
        {showFavoriteButton &&
          <FavoriteButton>
            <IconButton onClick={onToggleFavorite} style={{height: 30, width: 30}}>
              <Tooltip placement="bottom" title={localization.get("button.add_to_favorites")}>
                {favorite ? <Star style={{fontSize: "20px", color: "white"}}/> : <StarBorder style={{fontSize: "22px", color: "white"}}/>}
              </Tooltip>
            </IconButton>
          </FavoriteButton>
        }
        {showAddToPlaylistButton &&
        <AddToPlaylist
          id={id}
          content={"contentCreators"}
          icon={
            <FavoriteButton>
              <IconButton style={{height: 30, width: 30}}>
                <Tooltip placement="bottom" title={localization.get("soundbar.add_to_playlist")}>
                   <PlaylistAdd style={{fontSize: "22px", color: "white", marginLeft: 4}}/>
                </Tooltip>
              </IconButton>
            </FavoriteButton>
          }
        />
        }
        {showShareButton &&
          <ShareButton>
            <IconButton onClick={onShare} style={{height: 30, width: 30}}>
              <Tooltip placement="bottom" title={localization.get("share")}>
                <Share style={{fontSize: "20px", color: "white"}}/>
              </Tooltip>
            </IconButton>
          </ShareButton>
        }
      </div>
    </SocialBanner>
  );
};

export const renderSocialLinksButtons = (socialLinks) =>
  socialLinks.slice(0,3).map(socialLink =>
    <Tooltip title={socialLink.type.capitalize()} placement={"top"}>
      <a href={socialLink.type === "email" ? `mailto:${socialLink.url}` : addHttpToUrl(socialLink.url)} target="_blank">
        <SocialButton>
          {renderIcon(socialLink.type)}
        </SocialButton>
      </a>
    </Tooltip>
  ).slice(0,4)

const renderIcon = (type) => {
  switch (type) {
    case "facebook":
      return <Facebook/>;
    case "twitter":
      return <Twitter/>;
    case "instagram":
      return <Instagram/>;
    case "linkedin":
      return <LinkedIn/>;
    case "vimeo":
      return <Vimeo/>;
    case "spotify":
      return <Spotify/>;
    case "soundcloud":
      return <SoundCloud/>;
    case "youtube":
      return <Youtube/>;
    case "web":
      return <Web/>;
    case "behance":
      return <Behance/>;
    case "email":
      return <Email/>
    case "twitch":
      return <Twitch/>
    case "tiktok":
      return <Tiktok/>
    case "linktree":
      return <Linktree/>
  }
}


const SocialBanner = styled.div`
  width: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  border-bottom-left-radius: 40px;
  border-bottom-right-radius: 40px;
  height: fit-content;
  // max-height: 385px;
  padding: 2rem 15px;
  background-image: linear-gradient(to bottom, #918e8e40, darkgray);
  @media (min-width: 479px) {
    width: 150px;
    background-color: #ffffff94;
  }
`;

const CloseButton = styled.div`
  position: relative;
  cursor: pointer;
`;

const FavoriteButton = styled.div`
  position: relative;
  border-radius: 10px;
  cursor: pointer;
  background-color: black;
  // top: 15px;
  margin: 0 5px;
`;

const AddToPlaylistButton = styled.div`
  position: relative;
  border-radius: 10px;
  cursor: pointer;
  background-color: black;
  top: 15px;
  margin: 0 5px;
`;

const ShareButton = styled.div`
  position: relative;
  border-radius: 10px;
  cursor: pointer;
  background-color: black;
  // top: 15px;
  margin: 0 5px;
`;

const SocialButtons = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

const SocialButton = styled.div`
  border-style: solid;
  border-width: 2px;
  border-radius: 50%;
  padding: 2px;
  border-color: black;
  cursor: pointer;
  margin: 2px;
`;

const Separator = styled.div`
  height: 2px;
  background-color: black;
  width: 70%;
  margin-bottom: 10px;
`;

const Name = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: black;
  -webkit-line-clamp: 2;
  min-height: 40px;
`;

const Profile = styled.div`
  background: url(${props => props.picture}) no-repeat;
  background-size: cover;
  width: 100px;
  height: 100px;
  border: 1px solid #676767;
  background-position-x: 50%;
  filter: blur(${props => props.blur ? "8px" : "0px"});
  -webkit-filter: blur(${props => props.blur ? "8px" : "0px"});
  top: 0;
  border-radius: 50%;
`;

const Contact = styled.div`
  cursor: pointer;
  color: #000000;
  margin-bottom: 20px;
  box-shadow: inset 1px 0 5px 1px #c3c3c3;
  padding: 0 10px;
  border-radius: 5px;
  &:hover {
    font-weight: bold;
  }
`;
